module.exports = __webpack_public_path__ + "static/media/7updown.232c48ad.png";